"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUser = void 0;
var config_1 = require("../helpers/config");
var envConsts_1 = require("../helpers/envConsts");
var fetchWithToken_1 = require("../token/fetchWithToken");
var getCurrentToken_1 = require("../token/getCurrentToken");
var parseUser_1 = require("./parseUser");
var parseJwt = function (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64)
        .split('')
        .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
};
var getOxygenId = function (accessToken) { return parseJwt(accessToken).userid; };
var fetchUser = function () {
    return (0, getCurrentToken_1.getCurrentToken)().then(function (_a) {
        var accessToken = _a.accessToken;
        var oxygenId = getOxygenId(accessToken);
        return (0, fetchWithToken_1.fetchWithToken)("".concat((0, config_1.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_V1_URL), "/users/").concat(oxygenId)).then(parseUser_1.parseUser);
    });
};
exports.fetchUser = fetchUser;
